
 const initialState = {
  tillDetails:'' 
} 

export default function tillListView( state = initialState, action) {
  console.log(action,"action.type====>productList",action.payload)
if(action.type==='Till_Details'){
    return {
      ...state,
      tillDetails:action.payload,
    }
  }
  return state; 

}


